export default "__VITE_ASSET__Db3C0N4F__"